import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { VBox } from "@ui/box/Box";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import Signal from "badmfck-signal";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";

interface TApiUserPopupProps {
	onSuccess: () => void;
	kid?: string;
	userId?: number;
}

export const S_API_USER_POPUP = new Signal<TApiUserPopupProps | null>("S_API_USER_POPUP");

export const ApiUserPopup = () => {
	useLocale();
	const request = S_API_USER_POPUP.use();

	if (!request) return null;

	const isEdit = !!request.kid;

	const closePopup = () => {
		S_API_USER_POPUP.invoke(null);
	};

	const onSuccess = () => {
		request.onSuccess();
		closePopup();
	};

	return (
		<Panel
			sx={{
				width: "90vw",
				maxWidth: "600px",
				maxHeight: "90vh",
				backgroundColor: "#EEF0F2",
			}}
			growContent
			decorator="absolute"
			label={isEdit ? msg("editApiUser") : msg("createApiUser")}
			onClose={closePopup}>
			<VBox>
				<Spacer size="12px" />
				<FormParser
					key={isEdit ? `api-user-edit-${request.kid}` : "api-user-create"}
					onRequest={async () => {
						const req = await GD.REQ_API.request({
							method: "api-keys/user/get",
							data: isEdit ? { id: request.userId } : { id: -1 },
						});
						return req;
					}}
					onSubmit={async (data: any) => {
						const req = await GD.REQ_API.request({
							method: isEdit ? "api-keys/user/update" : "api-keys/user/create",
							data: isEdit ? { ...data, kid: request.kid } : data,
						});
						return req;
					}}
					onComplete={onSuccess}
				/>
			</VBox>
		</Panel>
	);
};
